import { HttpClient } from '../http-client';
import { Project } from '../project';
import { SpaceTab } from './space-tab';

export interface Space {
  spaceId: number;
  spaceName: string;
  spaceTabs: Array<SpaceTab>;
  private: boolean;
  project: Pick<Project, 'projectId' | 'projectName'>;
  spaceTabOrder?: [];
}

export interface SpaceTabOrder {
  spaceId: number;
  spaceTabOrder: Array<number>;
}

export interface SpaceOrder {
  private: Array<number>;
  shared: Array<number>;
}

export interface ReorderSpaces {
  projectId: number;
  spaceOrder: SpaceOrder;
}

class SpaceHttpClient extends HttpClient {
  public async getSpaces(projectId: number): Promise<Space[]> {
    return this.get<Space[]>(`/projects/${projectId}/spaces`);
  }

  public async getSpaceDetail(spaceId: number): Promise<Space> {
    return this.get<Space>(`/spaces/${spaceId}`);
  }

  public async createSpace(data): Promise<Space> {
    return this.post<Space, Partial<Space>>('/spaces', data);
  }

  public async updateSpace(spaceId: number, data): Promise<Space> {
    return this.put<Space, Partial<Space>>(`/spaces/${spaceId}`, data);
  }

  public async deleteSpace(spaceId: number) {
    return this.delete(`/spaces/${spaceId}`);
  }

  public async bulkReorderSpaceTabs(
    data: Array<SpaceTabOrder>,
  ): Promise<Space> {
    return this.put('spaces/bulk-reorder-space-tabs', data);
  }

  public async bulkReorderSpaces(data: ReorderSpaces): Promise<Space> {
    return this.put('projects/bulk-reorder-spaces', data);
  }
}

export const SpaceAPI = new SpaceHttpClient();
